function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import moment from 'moment';
import messages from '../../../../messages';
import styles from '../../Results.pcss';
const PrintablePatient = ({ patient, accountPatientProfile, isPatientMode })=>{
    const { firstName, lastName } = patient || {};
    const { firstName: accountFirstName, lastName: accountLastName } = accountPatientProfile || {};
    const isVisible = isPatientMode || firstName || lastName || accountFirstName || accountLastName;
    return /*#__PURE__*/ _jsx("div", {
        className: "col",
        children: /*#__PURE__*/ _jsx("div", {
            className: cn('row align-items-center', styles.reportInfo),
            children: isVisible ? /*#__PURE__*/ _jsxs("div", {
                className: "col",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: cn('text--h3', styles.reportInfo__label),
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.info))
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "text--h1 mb-2",
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.for)),
                                    /*#__PURE__*/ _jsx("br", {})
                                ]
                            }),
                            isPatientMode ? `${accountFirstName} ${accountLastName}` : `${firstName} ${lastName}`
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.reportInfo__time,
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.generated)),
                            ' ',
                            moment().format('l')
                        ]
                    })
                ]
            }) : null
        })
    });
};
export default PrintablePatient;
